var __rspack_ns_object = JSON.parse('{"Copied":"Gekopieerd","Failed to copy":"Kopiëren mislukt"}')